export const LOGIN_SUCCESS: string = 'LOGIN_SUCCESS';
export const LOGIN_FAIL: string = 'LOGIN_FAIL';

export const SAVE_USER: string = 'SAVE_USER';
export const REMOVE_USER: string = 'REMOVE_USER';

export const NOTIFICATION: string = 'NOTIFICATION';

export const RECEIVE_ORIGIN_PORTS: string = 'RECEIVE_ORIGIN_PORTS';
export const RECEIVE_DESTINATION_PORTS: string = 'RECEIVE_DESTINATION_PORTS';
export const SET_SELECTED_ARRIVAL_PORT: string = 'SET_SELECTED_ARRIVAL_PORT';
export const SET_SELECTED_ORIGIN_PORT: string = 'SET_SELECTED_ORIGIN_PORT';
export const SET_SELECTED_DESTINATION_GHA_ID: string = 'SET_SELECTED_DESTINATION_GHA_ID';
export const SET_SELECTED_ORIGIN_GHA_ID: string = 'SET_SELECTED_ORIGIN_GHA_ID';
export const GET_GHA_INFO_SUCCEEDED: string = 'GET_GHA_INFO_SUCCEEDED';
export const GET_AWB_PART_STATUSES: string = 'GET_AWB_PART_STATUSES';

export const GET_AWBS_PENDING: string = 'GET_AWBS_PENDING';
export const GET_AWBS_FAILED: string = 'GET_AWBS_FAILED';
export const GET_AWBS_SUCCEEDED: string = 'GET_AWBS_SUCCEEDED';
export const GET_AWBS_EXPORT_SUCCEEDED: string = 'GET_AWBS_EXPORT_SUCCEEDED';
export const GET_AWBS_GHA_SUCCEEDED: string = 'GET_AWBS_GHA_SUCCEEDED';
export const GET_AWBS_FILTER: string = 'GET_AWBS_FILTER';
export const DELETE_AWBS: string = 'DELETE_AWBS';

export const RESET_CART: string = 'RESET_CART';
export const GET_CART: string = 'GET_CART';

export const RESET_TRUCK_CART: string = 'RESET_TRUCK_CART';
export const GET_TRUCK_CART: string = 'GET_TRUCK_CART';

export const REQUEST_START: string = 'REQUEST_START';
export const REQUEST_FINISH: string = 'REQUEST_FINISH';

export const GET_ADDITIONAL_SERVICES_AND_TARIFF: string = 'GET_ADDITIONAL_SERVICES_AND_TARIFF';

export const RECEIVE_PICKUP_DATE: string = 'RECEIVE_PICKUP_DATE';

export const SET_ORDER: string = 'SET_ORDER';

export const OPEN_NETWORK_ERROR_MODAL: string = 'OPEN_NETWORK_ERROR_MODAL';
export const CLOSE_NETWORK_ERROR_MODAL: string = 'CLOSE_NETWORK_ERROR_MODAL';

export const OPEN_TERMS_MODAL: string = 'OPEN_TERMS_MODAL';
export const CLOSE_TERMS_MODAL: string = 'CLOSE_TERMS_MODAL';

export const GET_FORWARDER_ACCOUNT_BALANCE: string = 'GET_FORWARDER_ACCOUNT_BALANCE';
export const GET_FORWARDER_E_WALLET_BALANCE: string = 'GET_FORWARDER_E_WALLET_BALANCE';

export const TRIGGER_MANAGED_EXPORT_RIGHT_SIDE_UPDATE: string = 'TRIGGER_MANAGED_EXPORT_RIGHT_SIDE_UPDATE';
export const STOP_MANAGED_EXPORT_RIGHT_SIDE_UPDATE: string = 'STOP_MANAGED_EXPORT_RIGHT_SIDE_UPDATE';

export const SET_ORDER_LOCKED_NUMBER: string = 'SET_ORDER_LOCKED_NUMBER';

export const OPEN_ERROR_MODAL: string = 'OPEN_ERROR_MODAL';
export const CLOSE_ERROR_MODAL: string = 'CLOSE_ERROR_MODAL';

export const INCREMENT_REQUEST_COUNTER_PO: string = 'INCREMENT_REQUEST_COUNTER_PO';
export const RESET_REQUEST_COUNTER_PO: string = 'RESET_REQUEST_COUNTER_PO';
export const INCREMENT_REQUEST_COUNTER_QUEUE: string = 'INCREMENT_REQUEST_COUNTER_QUEUE';
export const RESET_REQUEST_COUNTER_QUEUE: string = 'RESET_REQUEST_COUNTER_QUEUE';

export const SET_MANUAL_ENTRY_EDIT_DATA: string = 'SET_MANUAL_ENTRY_EDIT_DATA';
export const SET_MANUAL_ENTRY_ADD_DATA: string = 'SET_MANUAL_ENTRY_ADD_DATA';
export const CLEAR_MANUAL_ENTRY_EDIT_DATA: string = 'CLEAR_MANUAL_ENTRY_EDIT_DATA';
export const CLEAR_MANUAL_ENTRY_ADD_DATA: string = 'CLEAR_MANUAL_ENTRY_ADD_DATA';

export const GET_OFFLINE_ENTRY_SUCCEEDED: string = 'GET_OFFLINE_ENTRY_SUCCEEDED';
export const CLEAR_OFFLINE_ENTRY_DATA: string = 'CLEAR_OFFLINE_ENTRY_DATA';
export const GET_AWBS_OFFLINE_SUCCEEDED: string = 'GET_AWBS_OFFLINE_SUCCEEDED';
export const CLEAR_AWBS_OFFLINE_DATA: string = 'CLEAR_AWBS_OFFLINE_DATA';

export const GET_DRIVER_QUEUE: string = 'GET_DRIVER_QUEUE';
export const GET_AVAILABLE_COUNTERS: string = 'GET_AVAILABLE_COUNTERS';
export const SET_USER_COUNTER: string = 'SET_USER_COUNTER';
export const SET_COUNTER_AIRLINES: string = 'SET_COUNTER_AIRLINES';

export const ENABLE_DISABLE_BUTTON_ON_API_CALL: string = 'ENABLE_DISABLE_BUTTON_ON_API_CALL';
export const SET_WAIT_LIST_ID: string = 'SET_WAIT_LIST_ID';
export const REMOVE_WAIT_LIST_ID: string = 'REMOVE_WAIT_LIST_ID';
export const SET_ORDER_UPDATE_VALUE: string = 'SET_ORDER_UPDATE_VALUE';
export const CHANGE_AWB_NUMBER: string = 'CHANGE_AWB_NUMBER';